export default [
  {
    name: "NotificationsSetting",
    path: "/notifications/setting",
    component: () =>
      import("@/modules/notifications/setting/pages/NotificationsSetting"),
    meta: {
      ability: [
        {
          resource: "notifications/setting",
          actions: ["read"],
        },
      ],
    },
  },
];
